import React from "react";
import {Modal, Button, Form, Alert} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import "./OpenExamAndAcceptSubmissionsDialog.css";

class OpenExamAndAcceptSubmissionsDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: false,
    };

    this.handleAcceptAllProposals = this.handleAcceptAllProposals.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async handleAcceptAllProposals() {
    const { studentFileProposals, onAcceptProposal } = this.props;

    for (const proposal of studentFileProposals) {
      if (!proposal.isAccepted) {
        try {
          const status = await onAcceptProposal(proposal._id);
          if (!status) {
            console.error(`Failed to accept proposal with ID: ${proposal._id}`);
          }
          await new Promise((resolve) => setTimeout(resolve, 100));
        } catch (error) {
          console.error(
            `Error accepting proposal with ID: ${proposal._id}`,
            error
          );
        }
      }
    }

    this.setState({
      showConfirmationDialog: false,
    });
  }

  async handleSubmit() {
    if (this.state.isChecked) {
      await this.handleAcceptAllProposals();
    }
    this.props.onSubmit();
  }

  render() {
    const { t } = this.props;

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        size="xs"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            {this.props.dialogApiError}
            {this.props.body}
          </Form.Group>
          {this.props.studentFileProposals.some(
            (p) => p.isAccepted === false
          ) && this.props.open ? (
            <Alert variant="warning">
              <p className="mb-2">
                <b>{t("SingleExamination.ConfirmationDialog.Open.SubmissionDescription")}</b>
              </p>

              <Form>
                <Form.Group controlId="formBasicCheckbox">
                  <div className="custom-checkbox">
                    <Form.Check
                        custom
                        type="checkbox"
                        label={t(
                            "SingleExamination.ConfirmationDialog.Open.SubmissionAccept"
                        )}
                        checked={this.state.isChecked}
                        onChange={(event) => {
                          this.setState({ isChecked: event.target.checked });
                        }}
                    />
                  </div>
                </Form.Group>
              </Form>
            </Alert>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button
            className={`btn btn-${this.props.cancelButtonVariant}`}
            onClick={() => {
              this.props.onHide();
              this.setState({ isChecked: false });
            }}
          >
            {this.props.t("DialogCancel")}
          </Button>
          <Button
            className={`btn btn-${this.props.confirmButtonVariant}`}
            onClick={() => this.handleSubmit()}
          >
            {this.props.t("DialogConfirm")}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(OpenExamAndAcceptSubmissionsDialog);
